import { MdArrowForward } from "react-icons/md";

interface ConflictButtonProps {
  title: string;
  subTitle: string;
  handleFunction: () => void;
}

const ConflictButton: React.FC<ConflictButtonProps> = ({
  title,
  subTitle,
  handleFunction,
}) => {
  return (
    <div
      className="group self-stretch p-4 rounded-2xl border border-[#d5770c] hover:border-warning-700 justify-start items-center gap-3 inline-flex cursor-pointer"
      onClick={handleFunction}
    >
      <div className="grow shrink basis-0 flex-col justify-center items-start gap-1 inline-flex">
        <div className="self-stretch justify-start items-center gap-2 inline-flex text-[#d5770c] group-hover:text-warning-700 text-base font-semibold font-sans leading-[19px] select-none">
          {title}
        </div>
        <div className="self-stretch text-[#d5770c] group-hover:text-warning-700 text-xs font-normal font-sans leading-[14px] select-none">
          {subTitle}
        </div>
      </div>
      <div className="p-3 bg-[#fdeedd] group-hover:bg-warning-300 ease-in-out duration-100 rounded-full justify-start items-start gap-2 flex">
        <div className="w-6 h-6 relative">
          <MdArrowForward className="w-full h-full fill-[#d5770c]" />
        </div>
      </div>
    </div>
  );
};

export default ConflictButton;
